import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "gfu-navbar-item" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-push-notification__indicator"
}
const _hoisted_3 = {
  key: 0,
  class: "_px-2"
}
const _hoisted_4 = {
  key: 1,
  class: "gfu-push-notification-list _flexcol"
}
const _hoisted_5 = {
  key: 0,
  class: "_bgc--primary-dark _py-2"
}
const _hoisted_6 = { class: "gfu-balloon__top-title _tc--white _px-2 _pb-2" }
const _hoisted_7 = { class: "_flexcol _gap-1" }
const _hoisted_8 = {
  key: 1,
  class: "_flex _jc-sb _pa-2"
}
const _hoisted_9 = { class: "gfu-balloon__top-title _tc--dark" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 3,
  class: "_mx-2 _mb-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_title = _resolveComponent("base-title")
  const _component_drawer_header = _resolveComponent("drawer-header")
  const _component_skeleton_notification = _resolveComponent("skeleton-notification")
  const _component_notification_action = _resolveComponent("notification-action")
  const _component_mobile_notification_center_unauthorized_user = _resolveComponent("mobile-notification-center-unauthorized-user")
  const _component_push_notification_list = _resolveComponent("push-notification-list")
  const _component_drawer = _resolveComponent("drawer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_button, {
      width: "narrow",
      theme: "default",
      "aria-label": _ctx.Resources.Layout.ActivitySectionTriggerLabel,
      onClick: $options.onOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_icon, {
          name: "bell",
          class: "_pos-r",
          size: "lg",
          "is-fixed-width": ""
        }, {
          default: _withCtx(() => [
            ($options.isNotificationBadgeVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass($options.notificationBadgeClasses),
                  "data-qa": "notification-icon:UnseenNotificationsNumber"
                }, [
                  (_ctx.unseenNotificationsCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.unseenNotificationsCount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["aria-label", "onClick"]),
    _createVNode(_component_drawer, {
      "is-open": _ctx.isDrawerOpen,
      onClose: $options.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_drawer_header, { onClose: $options.onClose }, {
          default: _withCtx(() => [
            _createVNode(_component_base_title, { level: "h3" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Layout.NotificationCenterTitle), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClose"]),
        (!_ctx.isDrawerOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (placeholder) => {
                return _createVNode(_component_skeleton_notification, {
                  key: placeholder,
                  class: "_mt-2"
                })
              }), 64 /* STABLE_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.pendingActions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Layout.ActionRequiredSectionTitle), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedPendingActions, (action) => {
                        return (_openBlock(), _createBlock(_component_notification_action, _mergeProps({
                          key: action.userPendingActionID
                        }, { ref_for: true }, action, {
                          class: "_px-2",
                          onActionDismissed: $options.onActionDismissed
                        }), null, 16 /* FULL_PROPS */, ["onActionDismissed"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.Resources.Layout.ActivitySectionTitle), 1 /* TEXT */),
                    _createElementVNode("a", {
                      class: "_tc--accent _tdn",
                      href: _ctx.subscriptionManagementUrl,
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onLinkClick && $options.onLinkClick(...args))),
                      "data-qa": "notification-box-link:CommunicationPreferences"
                    }, _toDisplayString(_ctx.Resources.Layout.CommunicationPreferencesLink), 9 /* TEXT, PROPS */, _hoisted_10)
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.isPushNotificationSettingsVisible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass($options.pushNotificationSettingsWrapperClasses)
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent($options.component), {
                      "active-change": "",
                      notifications: $setup.notifications,
                      onHidePushNotificationSettings: $options.onHidePushNotificationSettings
                    }, null, 40 /* PROPS, NEED_HYDRATION */, ["notifications", "onHidePushNotificationSettings"]))
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (!$options.hasPushNotificationCapability && !_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_mobile_notification_center_unauthorized_user, { onSuccess: $options.onAuthenticated }, null, 8 /* PROPS */, ["onSuccess"])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createBlock(_component_push_notification_list, {
                    key: 4,
                    "active-change": "",
                    notifications: $setup.notifications
                  }, null, 8 /* PROPS */, ["notifications"]))
                : _createCommentVNode("v-if", true)
            ]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "onClose"])
  ]))
}